import { render, staticRenderFns } from "./MenuDailyRoutine.vue?vue&type=template&id=22600817&"
import script from "./MenuDailyRoutine.vue?vue&type=script&lang=js&"
export * from "./MenuDailyRoutine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports